export default __webpack_public_path__ + "static/media/P200-Tip.13bfe08e.svg";